import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import moment from 'moment';
import 'moment/locale/si';
import "moment-precise-range-plugin"; // Import the plugin to extend moment

function HCViewErashtaka({ tableData }) {
    const { t } = useTranslation();
    const lang = localStorage.getItem('language') || 'si';
    moment.locale(lang); // Set the locale based on the selected language
    const dataTableData = {
        columns: [
          { Header: t("Name"), accessor: "name" },
          { Header: t("From"), accessor: "from",
            Cell : ({ cell }) => moment(new Date(cell.row.original.from)).format('YYYY MMMM DD')
           },
          { Header: t("To"), accessor: "to",
            Cell : ({ cell }) => moment(new Date(cell.row.original.to)).format('YYYY MMMM DD')
           },
          { Header: "", accessor: "duration"},
          { Header: "", accessor: "ageText" },
        
        ],
        rows:tableData
    }

    return (
            <MDBox pt={0} pb={1} >
                <MDBox mb={1}>
                    <Card>
                        {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                            <MDTypography variant="h5" fontWeight="medium">
                            ඒරාෂ්ටක
                            </MDTypography>
                        <Divider  variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                        </MDBox> */}
                        <DataTable 
                        canSearch={false} 
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                    </Card>
                </MDBox>
            </MDBox>
    );
};

HCViewErashtaka.propTypes = {
    tableData: PropTypes.array,
  };

export default HCViewErashtaka;